module.exports = __webpack_public_path__ + "static/media/sprinkler.6eb68f60.svg";